import React from 'react';
import { Route, IndexRoute } from 'react-router';
import AccountSuspendedPage from './containers/account-suspended-page';
import App from './containers/app';
import CategoriesLink from './containers/categories-link';
import FeedPage from './containers/feed-page';
import CategoryPage from './containers/category-page';
import CategoryMobileHeader from './containers/category-mobile-header';
import CategoryDesktopHeader from './containers/category-desktop-header';
import LoginPage from './containers/login-page';
import NotFoundPage from './containers/error-page/not-found-page';
import ServerErrorPage from './containers/error-page/server-error-page';
import PostEditorPageOrModal from './containers/post-editor-page-or-modal';
import SearchResultsPage from './containers/search-results-page';
import ArchivePage from './containers/archive-page';
import SearchDesktopHeader from './containers/search-header/search-desktop-header';
import SearchMobileHeader from './containers/search-header/search-mobile-header';
import SearchPage from './containers/search-page';
import forMobileOnly from './hoc/for-mobile-only';
import withPerformanceTracking from './hoc/with-performance-tracking';
import { PostRoutes } from './post-routes';

// DANGER!!! New routes can only be 4 chars length or shorter!
// If you are lucky you can take route from black listed slugs in - communities-node-server/app/services/slug-service.js

const categoryRouteProps = {
  name: 'Category',
  components: {
    main: CategoryPage,
    mobileHeader: CategoryMobileHeader,
    mobileMenu: forMobileOnly(CategoriesLink),
    desktopHeader: CategoryDesktopHeader,
  },
};

export default () => (
  <Route path="/" name="Wix Social Blog" component={App}>
    <Route
      path="404"
      components={{ main: NotFoundPage, mobileHeader: CategoryMobileHeader, desktopHeader: CategoryDesktopHeader }}
    />
    <Route
      path="500"
      components={{ main: ServerErrorPage, mobileHeader: CategoryMobileHeader, desktopHeader: CategoryDesktopHeader }}
    />
    <Route
      path="search"
      name="Search"
      components={{
        main: SearchPage,
        mobileHeader: SearchMobileHeader,
        desktopHeader: SearchDesktopHeader,
      }}
    />
    <Route
      path="search/:query"
      name="Search"
      components={{
        main: SearchResultsPage,
        mobileHeader: SearchMobileHeader,
        desktopHeader: SearchDesktopHeader,
      }}
    />
    <Route
      path="create-post"
      name="Create Post"
      components={{
        main: PostEditorPageOrModal,
        desktopHeader: CategoryDesktopHeader,
      }}
    />
    <Route path="login" name="Login" components={{ main: LoginPage, desktopHeader: CategoryDesktopHeader }} />
    <Route
      path="account-suspended"
      name="Account Suspended"
      components={{
        main: AccountSuspendedPage,
        mobileHeader: CategoryMobileHeader,
        desktopHeader: CategoryDesktopHeader,
      }}
    />
    <Route path="categories/:categorySlug/:subcategorySlug(/page/:page)" {...categoryRouteProps} />
    <Route path="category/:categorySlug/:subcategorySlug(/page/:page)" {...categoryRouteProps} />
    <Route path="categories/:categorySlug(/page/:page)" {...categoryRouteProps} />
    <Route path="category/:categorySlug(/page/:page)" {...categoryRouteProps} />
    <Route
      path="archive/:year/:month"
      components={{
        main: ArchivePage,
        mobileHeader: CategoryMobileHeader,
        desktopHeader: CategoryDesktopHeader,
      }}
    />
    <Route
      path="archive/:year/:month/page/:pageIndex"
      components={{
        main: ArchivePage,
        mobileHeader: CategoryMobileHeader,
        desktopHeader: CategoryDesktopHeader,
      }}
    />
    <Route
      path="page/:page"
      components={{
        main: FeedPage,
        mobileHeader: CategoryMobileHeader,
        desktopHeader: CategoryDesktopHeader,
      }}
    />
    {PostRoutes}
    <IndexRoute
      components={{
        main: withPerformanceTracking({ context: 'communities-blog-app' })(FeedPage),
        mobileHeader: CategoryMobileHeader,
        mobileMenu: forMobileOnly(CategoriesLink),
        desktopHeader: CategoryDesktopHeader,
      }}
    />
    <Route
      path="*"
      components={{ main: NotFoundPage, mobileHeader: CategoryMobileHeader, desktopHeader: CategoryDesktopHeader }}
    />
  </Route>
);
